<template>
  <el-dialog title="重复配置列表" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <div class="table_main">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }" @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent" show-overflow height="385" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>
                <div class="clearfix screen-btns"
                     style="background-color: #FFF6EC;color:#F59F34;line-height: 28px;padding-left: 10px;">
                  <span><i class="el-icon-warning"></i>下面的列表为已经存在的配置，确定要覆盖保存吗？</span>
                  <div class="fr">
                    <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                      status="primary" plain>重置</vxe-button> -->
                    <vxe-button status="warning" icon="el-icon-folder-add" class="button-sty"
                                style="background-color: #FFEFEF;color: #FF6263;"
                                @click="doSave">确定覆盖保存</vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>

    <!--		<span slot="footer" class="dialog-footer">-->
    <!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
    <!--			<el-button type="primary" plain class="button-sty" @click="dialogClose">-->
    <!--				<i class="el-icon-close el-icon"></i>-->
    <!--				取 消-->
    <!--			</el-button>-->
    <!--			<el-button type="primary" @click="commitRow" class="button-sty">-->
    <!--				<i class="el-icon-check el-icon"></i>-->
    <!--				确 定-->
    <!--			</el-button>-->
    <!--		</span>-->
  </el-dialog>
</template>
<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param'],
  mixins: [selectDialogMixins],
  components: { pager },

  created() {
    this.initSetting();
    this.formData.beginDate = this.param.beginDate
    this.formData.endDate = this.param.endDate
    this.formData.siteId = this.param.siteId
    this.formData.brandId = this.param.brandId
    this.formData.serviceTypeIds = this.param.serviceTypeIds
    this.formData.buyChannelIds = this.param.buyChannelIds
    this.formData.itemCategoryIds = this.param.itemCategoryIds
    this.formData.areaId = this.param.areaId
    this.formData.isAllBrandId = this.param.isAllBrandId
    this.formData.isAllServerTypes = this.param.isAllServerTypes
    this.formData.isAllBuyChannel = this.param.isAllBuyChannel
    this.formData.isAllItemCategory = this.param.isAllItemCategory
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },
  data() {
    return {
      total: 0,
      filterText: '',
      data: [],
      pageSizes: [10, 20, 100],
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        id: '', name: ''
      }
    };
  },


  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent(e) {
      console.log(e.row.id, '单元格点击事件')
    },


    radioChangeEvent({ row }) {
      this.selectedRow = { id: row.id, name: row.userName }
    },


    commitRow() {
      this.$emit('commitSelectedRow', this.selectedRow)
      this.dialogClose()
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },




    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/snAutoDispatch/getDispatchByTime',
        param: this.formData,
        method: 'post',
        columns: [
          {title: '服务商', field: 'siteName', width: 130,},
          // {title: '网点编码', field: 'siteCode', width: 150,},
          {title: '品牌', field: 'brandName', width: 110,},
          {title: '服务类型', field: 'serviceTypeName', width: 130,},
          {title: '产品大类', field: 'bigCategoryName', width: 110,},
          {title: '产品小类', field: 'smallCategoryName', width: 110,},
          {title: '购买渠道', field: 'buyChannelName', width: 110,},
          {title: '地区', field: 'areaName', width: 300,},
          { field: 'beginDate', title: '有效时间', width: 150,  slots: {
              default: ({row}) => {
                return [
                  <div><span>{row.beginDate}至{row.endDate}</span></div>
                ]
              }
            }
          },

        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    doSave(){
      this.$emit('commitSave', false)
    }
  }
};
</script>
<style lang="scss" scoped>
#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}
</style>

